var _g, _g2, _path, _rect, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGymMapIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 45,
    viewBox: "0 0 39 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1989_9842)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.5183,
    cy: 39.5781,
    rx: 5.1726,
    ry: 1.84736,
    fill: "black",
    fillOpacity: 0.2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1989_9842)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5178 3C28.0881 3 35.0356 9.94756 35.0356 18.5178C35.0356 25.0889 30.9513 30.7061 25.1828 32.9691L20.4017 39.5043C20.302 39.6411 20.1696 39.7528 20.0158 39.8298C19.862 39.9069 19.6912 39.9472 19.5178 39.9472C19.3445 39.9472 19.1736 39.9069 19.0198 39.8298C18.866 39.7528 18.7336 39.6411 18.634 39.5043L13.8528 32.9691C8.08433 30.7061 4 25.0889 4 18.5178C4 9.94756 10.9476 3 19.5178 3Z",
    fill: "#00A997"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.1241 18.562C32.1241 11.6242 26.4999 6 19.562 6C12.6242 6 7 11.6242 7 18.562C7 25.4999 12.6242 31.1241 19.562 31.1241C26.4999 31.1241 32.1241 25.4999 32.1241 18.562Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1989_9842",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 9,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 9,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1989_9842)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.7227 16.7705L22.1919 12.2397L22.5102 11.9215C22.7973 11.6344 23.153 11.494 23.5774 11.5002C24.0018 11.5064 24.3575 11.6531 24.6446 11.9402L27.0597 14.3553C27.3468 14.6424 27.4903 14.995 27.4903 15.4132C27.4903 15.8313 27.3468 16.1839 27.0597 16.471L26.7227 16.7705ZM17.4926 26.038C17.2056 26.3251 16.853 26.4686 16.4348 26.4686C16.0167 26.4686 15.6641 26.3251 15.377 26.038L12.9619 23.6229C12.6748 23.3358 12.5312 22.9832 12.5312 22.5651C12.5312 22.1469 12.6748 21.7943 12.9619 21.5072L13.2614 21.2077L17.7922 25.7385L17.4926 26.038ZM20.2074 25.5138C20.0576 25.6636 19.8829 25.7385 19.6832 25.7385C19.4834 25.7385 19.3087 25.6636 19.1589 25.5138L13.4861 19.841C13.3363 19.6912 13.2614 19.5164 13.2614 19.3167C13.2614 19.117 13.3363 18.9423 13.4861 18.7925L14.5533 17.7066C14.703 17.5569 14.8809 17.482 15.0868 17.482C15.2928 17.482 15.4706 17.5569 15.6204 17.7066L16.7999 18.8861L19.9078 15.7782L18.7283 14.5987C18.5785 14.449 18.5037 14.2742 18.5037 14.0745C18.5037 13.8748 18.5785 13.7001 18.7283 13.5503L19.7955 12.4644C19.9453 12.3146 20.1231 12.2397 20.3291 12.2397C20.535 12.2397 20.7129 12.3146 20.8627 12.4644L26.5355 18.1372C26.6853 18.287 26.7602 18.4649 26.7602 18.6708C26.7602 18.8768 26.6853 19.0546 26.5355 19.2044L25.4496 20.2716C25.2998 20.4214 25.1251 20.4962 24.9254 20.4962C24.7257 20.4962 24.5509 20.4214 24.4012 20.2716L23.2217 19.0921L20.1138 22.2L21.2933 23.3795C21.443 23.5293 21.5179 23.7071 21.5179 23.9131C21.5179 24.119 21.443 24.2969 21.2933 24.4466L20.2074 25.5138Z",
    fill: "#795548"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1989_9842",
    x: 12.8678,
    y: 36.2528,
    width: 13.3005,
    height: 6.65064,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.738955,
    result: "effect1_foregroundBlur_1989_9842"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1989_9842",
    x: 0.305226,
    y: 0.0441809,
    width: 38.4247,
    height: 44.3368,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.738955
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.84739
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1989_9842"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1989_9842",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGymMapIcon);
export default __webpack_public_path__ + "static/media/gymMapIcon.9c5e9bc3a55b90c76f50f4478e1c8b08.svg";
export { ForwardRef as ReactComponent };